const types = {
  CHARACTER : 'CHARACTER',
  BRACKET: 'BRACKET',
  RANGE: 'RANGE',
  PARENTHESIS : 'PARENTHESIS',
  START: 'START',
  BACK_REFERENCE: 'BACK_REFERENCE'
}

export default types;